import React from 'react';
import {
  Bootstrap,
} from '../components';

import {
  Header,
  Footer
} from '../containers';

import fetch from 'isomorphic-fetch';
import api from '../api';

/**
 * Home页面
 */
export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: 'Loading...'
    }
  }

  componentDidMount() {
    fetch(api.index) 
      .then(
        response => response.json(),
        error    => console.log("系统出错：", error)
      ) 
      .then(json => {
          this.setState({text: json.data});
      }) 

  }

  componentWillUnmount() {
  }

  render() {
    return (
      <div>
        <Header data={this.props.data} />
        <Bootstrap.Container>
            <Bootstrap.Jumbotron>
              <h1>欢迎访问</h1>
              <p>郑州立行信息技术有限公司,ERP系统产品研发、实施服务。</p>
            </Bootstrap.Jumbotron>
            <Bootstrap.Row>
              <div className="col-md-4">
                  {Bootstrap.Panel({
                    'title': "软件开发服务", 
                    'text': `主要提供管理类软件开发服务,如ERP、OA、CRM、HR等领域的软件系统,` +
                        `可根据客户实际需求进行软件程序设计与开发，并能快速实现特定系统功能,` +
                        `定制化的软件可最大限度的适应原管理环境、降低使用难度.`
                  })}
              </div>
              <div className="col-md-4">
                  {Bootstrap.Panel({
                    'title': "应用集成服务", 
                    'text': "提供应用集成服务，对已有管理系统的功能增强, 根据需要对应用程序进行集成，逐步升级已有系统的可用性.  "
                  })}
              </div>
              <div className="col-md-4">
                  {Bootstrap.Panel({
                    'title': "系统运维服务", 
                    'text': "对软件应用系统系统部署、运维等服务， 定期维护,保证系统稳定运行。"
                  })}
              </div>
            </Bootstrap.Row>
        </Bootstrap.Container>
        <Footer footer={this.props.footer}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Home.js